var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleStartup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 824,
    height: 100,
    viewBox: "0 0 824 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.69853302,0,0,-0.69852941,1,3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.7,-52.6 c 0,29 24.3,52.5 53.3,52.5 16,0 27.4,-6.3 36,-14.5 L 79.8,-24.7 c -6.1,5.8 -14.4,10.3 -25.8,10.3 -21.1,0 -37.6,-17 -37.6,-38.1 0,-21.1 16.5,-38.1 37.6,-38.1 13.7,0 21.5,5.5 26.5,10.5 4.1,4.1 6.8,10 7.8,18 H 54 v 14.3 h 48.3 c 0.5,-2.6 0.8,-5.6 0.8,-9 0,-10.8 -2.9,-24.1 -12.4,-33.5 C 81.4,-99.9 69.6,-105 54,-105 25,-105 0.7,-81.5 0.7,-52.6 Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142,-37.5 c -18.7,0 -33.9,-14.2 -33.9,-33.8 0,-19.5 15.2,-33.8 33.9,-33.8 18.7,0 33.9,14.3 33.9,33.8 0,19.6 -15.2,33.8 -33.9,33.8 z m 0,-54.2 c -10.2,0 -19.1,8.4 -19.1,20.5 0,12.2 8.8,20.5 19.1,20.5 10.2,0 19.1,-8.3 19.1,-20.5 0,-12.1 -8.9,-20.5 -19.1,-20.5 z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 216,-37.5 c -18.7,0 -33.9,-14.2 -33.9,-33.8 0,-19.5 15.2,-33.8 33.9,-33.8 18.7,0 33.9,14.3 33.9,33.8 0,19.6 -15.2,33.8 -33.9,33.8 z m 0,-54.2 c -10.2,0 -19.1,8.4 -19.1,20.5 0,12.2 8.8,20.5 19.1,20.5 10.3,0 19.1,-8.3 19.1,-20.5 0,-12.1 -8.9,-20.5 -19.1,-20.5 z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 306.8,-39.5 V -45 h -0.5 c -3.3,4 -9.7,7.6 -17.8,7.6 -16.9,0 -32.4,-14.8 -32.4,-33.9 0,-18.9 15.5,-33.7 32.4,-33.7 8.1,0 14.5,3.6 17.8,7.7 h 0.5 v -4.9 c 0,-12.9 -6.9,-19.8 -18,-19.8 -9.1,0 -14.7,6.5 -17,12 l -12.9,-5.4 c 3.7,-9 13.6,-20 30,-20 17.4,0 32.1,10.2 32.1,35.2 v 60.7 z m -17,-52.2 c -10.2,0 -18.8,8.6 -18.8,20.4 0,11.9 8.6,20.6 18.8,20.6 10.1,0 18,-8.7 18,-20.6 0.1,-11.9 -7.9,-20.4 -18,-20.4 z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346,-103 331.2,-103 331.2,-3.7 346,-3.7 ",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 386.7,-91.7 c -7.6,0 -12.9,3.5 -16.4,10.2 l 45.2,18.7 -1.5,3.8 c -2.8,7.6 -11.4,21.5 -28.9,21.5 -17.4,0 -31.9,-13.7 -31.9,-33.8 0,-18.9 14.3,-33.8 33.5,-33.8 15.5,0 24.4,9.5 28.2,15 l -11.5,7.7 c -3.9,-5.6 -9.1,-9.3 -16.7,-9.3 z m -1.1,41.2 c 5.9,0 10.9,-2.9 12.5,-7.2 l -30.2,-12.5 c -0.4,13 10.1,19.7 17.7,19.7 z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-136 416,-136 416,0 0,0 ",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2707104,0,0,2.2707104,183.62468,309.94175)",
    "aria-label": "for Startups"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 68.176484,-132.13108 q 2,0 3.28,0.68 l -1,3.24 q -0.96,-0.48 -2.16,-0.48 -1.36,0 -2.24,0.96 -0.84,0.92 -0.84,2.48 v 2.48 h 5.12 v 3.36 h -5.12 v 16.24 h -3.68 v -16.24 h -3.68 v -3.36 h 3.68 v -2.84 q 0,-2.92 1.84,-4.72 1.88,-1.8 4.8,-1.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 71.532109,-112.97108 q 0,-4.52 2.84,-7.48 2.88,-2.96 7.24,-2.96 4.36,0 7.2,2.96 2.88,2.96 2.88,7.48 0,4.56 -2.88,7.48 -2.84,2.96 -7.2,2.96 -4.36,0 -7.24,-2.96 -2.84,-2.96 -2.84,-7.48 z m 3.68,0 q 0,3.16 1.84,5.12 1.84,1.96 4.56,1.96 2.72,0 4.56,-1.96 1.84,-1.96 1.84,-5.12 0,-3.12 -1.84,-5.08 -1.88,-2 -4.56,-2 -2.68,0 -4.56,2 -1.84,1.96 -1.84,5.08 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 98.363359,-103.17108 h -3.68 v -19.6 h 3.52 v 3.2 h 0.16 q 0.56,-1.56 2.280001,-2.64 1.76,-1.12 3.44,-1.12 1.6,0 2.72,0.48 l -1.12,3.56 q -0.68,-0.28 -2.16,-0.28 -2.08,0 -3.640001,1.68 -1.52,1.68 -1.52,3.92 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 135.19086,-110.81108 q 0,3.76 -2.76,6.04 -2.8,2.24 -6.8,2.24 -3.56,0 -6.28,-2.08 -2.72,-2.08 -3.76,-5.68 l 3.52,-1.44 q 0.36,1.28 1,2.32 0.64,1.04 1.48,1.8 0.88,0.72 1.92,1.16 1.04,0.4 2.2,0.4 2.52,0 4.12,-1.28 1.6,-1.32 1.6,-3.48 0,-1.8 -1.32,-3.08 -1.24,-1.24 -4.64,-2.4 -3.44,-1.24 -4.28,-1.68 -4.56,-2.32 -4.56,-6.84 0,-3.16 2.52,-5.4 2.56,-2.24 6.28,-2.24 3.28,0 5.68,1.68 2.4,1.64 3.2,4.12 l -3.44,1.44 q -0.48,-1.6 -1.92,-2.64 -1.4,-1.08 -3.44,-1.08 -2.16,0 -3.64,1.2 -1.48,1.12 -1.48,2.92 0,1.48 1.16,2.56 1.28,1.08 5.56,2.56 4.36,1.48 6.2,3.64 1.88,2.12 1.88,5.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 145.72461,-102.85108 q -2.4,0 -4,-1.48 -1.56,-1.48 -1.6,-4.12 v -10.96 h -3.44 v -3.36 h 3.44 v -6 h 3.68 v 6 h 4.8 v 3.36 h -4.8 v 9.76 q 0,1.96 0.76,2.68 0.76,0.68 1.72,0.68 0.44,0 0.84,-0.08 0.44,-0.12 0.8,-0.28 l 1.16,3.28 q -1.44,0.52 -3.36,0.52 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 154.39461,-109.17108 q 0,1.44 1.2,2.4 1.24,0.96 2.88,0.96 2.32,0 4.12,-1.72 1.84,-1.72 1.84,-4.04 -1.72,-1.36 -4.8,-1.36 -2.24,0 -3.76,1.08 -1.48,1.08 -1.48,2.68 z m 4.76,-14.24 q 4.08,0 6.44,2.2 2.36,2.16 2.36,5.96 v 12.08 h -3.52 v -2.72 h -0.16 q -2.28,3.36 -6.08,3.36 -3.24,0 -5.44,-1.92 -2.16,-1.92 -2.16,-4.8 0,-3.04 2.28,-4.84 2.32,-1.8 6.16,-1.8 3.28,0 5.4,1.2 v -0.84 q 0,-1.92 -1.52,-3.24 -1.52,-1.36 -3.56,-1.36 -3.08,0 -4.88,2.6 l -3.24,-2.04 q 2.68,-3.84 7.92,-3.84 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 195.06523,-102.85108 q -2.4,0 -4,-1.48 -1.56,-1.48 -1.6,-4.12 v -10.96 h -3.44 v -3.36 h 3.44 v -6 h 3.68 v 6 h 4.8 v 3.36 h -4.8 v 9.76 q 0,1.96 0.76,2.68 0.76,0.68 1.72,0.68 0.44,0 0.84,-0.08 0.44,-0.12 0.8,-0.28 l 1.16,3.28 q -1.44,0.52 -3.36,0.52 z m -22.96,-19.92 h 3.52 v 3.2 h 0.16 q 1.64,-3.76 6.76,-3.76 l 0.76,0.08 v 3.84 l -1.64,-0.16 q -2.56,0 -4.24,1.6 -1.64,1.56 -1.64,4 v 10.8 h -3.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 218.68023,-103.17108 h -3.52 v -2.72 h -0.16 q -0.84,1.44 -2.6,2.4 -1.72,0.96 -3.6,0.96 -3.6,0 -5.56,-2.04 -1.92,-2.08 -1.92,-5.88 v -12.32 h 3.68 v 12.08 q 0.12,4.8 4.84,4.8 2.2,0 3.68,-1.76 1.48,-1.8 1.48,-4.28 v -10.84 h 3.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 232.79898,-105.89108 q 2.64,0 4.44,-2 1.8,-1.96 1.8,-5.08 0,-3.08 -1.8,-5.08 -1.8,-2 -4.44,-2 -2.68,0 -4.48,2 -1.76,2 -1.76,5.08 0,3.12 1.76,5.12 1.8,1.96 4.48,1.96 z m 0.6,3.36 q -2.16,0 -3.96,-0.92 -1.76,-0.92 -2.72,-2.44 h -0.16 l 0.16,2.72 v 8.640004 h -3.68 v -28.240004 h 3.52 v 2.72 h 0.16 q 0.96,-1.52 2.72,-2.44 1.8,-0.92 3.96,-0.92 3.88,0 6.56,3.04 2.76,3.08 2.76,7.4 0,4.36 -2.76,7.4 -2.68,3.04 -6.56,3.04 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "ProductSans",
      fill: "#000000",
      fillOpacity: 0.541176
    },
    d: "m 260.85523,-108.61108 q 0,2.56 -2.24,4.32 -2.24,1.76 -5.64,1.76 -2.96,0 -5.2,-1.52 -2.24,-1.56 -3.2,-4.08 l 3.28,-1.4 q 0.72,1.76 2.08,2.76 1.4,0.96 3.04,0.96 1.76,0 2.92,-0.76 1.2,-0.76 1.2,-1.8 0,-1.88 -2.88,-2.76 l -3.36,-0.84 q -5.72,-1.44 -5.72,-5.52 0,-2.68 2.16,-4.28 2.2,-1.64 5.6,-1.64 2.6,0 4.68,1.24 2.12,1.24 2.96,3.32 l -3.28,1.36 q -0.56,-1.24 -1.84,-1.92 -1.24,-0.72 -2.8,-0.72 -1.44,0 -2.6,0.72 -1.12,0.72 -1.12,1.76 0,1.68 3.16,2.4 l 2.96,0.76 q 5.84,1.44 5.84,5.88 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStartup);
export default __webpack_public_path__ + "static/media/googleStartup.0017c50205ce01f0d7789772defc15f4.svg";
export { ForwardRef as ReactComponent };